import React, { useEffect, useState } from 'react';
import { withAuctionCore } from 'agent';
import PropTypes from 'prop-types';
import {
  Container, Label, SelectBox, FormWrapper, SoldOnlyContainer,
} from './styles';

const Filters = ({
  auctioncore, setMonths, setLocation, setSoldOnly, soldOnly,
}) => {
  const [locations, setLocations] = useState([]);

  const periods = [];
  for (let i = 1; i <= 12; i += 1) {
    const text = i === 1 ? 'month' : 'months';
    periods.push({
      value: i,
      text: `${i} ${text}`,
    });
  }

  useEffect(() => {
    auctioncore.getLocations()
      .then((response) => {
        setLocations((response.data.lookupItems));
      })
      .catch((error) => console.log(error));
  }, [

  ]);

  return (
    <Container>
      <FormWrapper>
        <SelectBox onChange={(e) => setLocation(e.target.value)}>
          <option value="">All Locations</option>
          {locations.map((item) => <option value={item.value}>{item.text}</option>)}
        </SelectBox>
        <SelectBox onChange={(e) => setMonths(e.target.value)}>
          {periods.map((item) => <option value={item.value} selected={item.value === 2}>{item.text}</option>)}
        </SelectBox>

        <SoldOnlyContainer>
          <Label>Sold Only</Label>
          <input type="checkbox" checked={soldOnly} onClick={(e) => setSoldOnly(!soldOnly)} />
        </SoldOnlyContainer>
      </FormWrapper>
    </Container>
  );
};

Filters.propTypes = {
  auctioncore: PropTypes.object.isRequired,
};

export default withAuctionCore(Filters);
